// Add horizontal scroll to tables
function checkTable() {
	var tableWrappers = document.querySelectorAll('.table-wrapper');

	// If any tables have been set to responsive
	if ( tableWrappers ) {
		for (var i = 0; i < tableWrappers.length; i++) {
			var table = tableWrappers[i].querySelector('table');

			// Check for a table, in case the wrapper has been misused
			if ( table ) {
				if ( table.clientWidth > tableWrappers[i].clientWidth ) {
					tableWrappers[i].classList.add('table-wrapper--too-narrow');
				} else {
					tableWrappers[i].classList.remove('table-wrapper--too-narrow');
				}
			}

		}
	}
}

checkTable();

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

var optimisedCheckTable = debounce(checkTable, 250); // Debounce for performance

// Fire on comparision modal load
var comparisonButton = document.querySelector( '.product-list-header__button .button' );
if ( comparisonButton ) {
	comparisonButton.addEventListener( 'click', function() {
		setTimeout( checkTable, 250 );
	});
}

window.addEventListener( 'resize', optimisedCheckTable );